module.exports = __webpack_public_path__ + "img/pci.34962dd9.png";